import { Col, Row } from 'antd';

import { ReactComponent as SettlementIcon } from '../../../../../assets/icons/check-list.svg';
import { ReactComponent as NotesIcon } from '../../../../../assets/icons/notes.svg';
import { ReactComponent as DetailsIcon } from '../../../../../assets/icons/save-2.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/icons/truck.svg';
import SvgConverter from '../../../../components/Common/SvgConverter';
import CollapsiblePanel from '../../../../components/Tabs/CollapsiblePanel';
import CreateOverChargeDetails from './Tabs/CreateOverChargeDetails';
import CreateOverChargeItems from './Tabs/CreateOverChargeItems';
import CreateOverChargeNotes from './Tabs/CreateOverChargeNotes';
import CreateOverChargeSettlements from './Tabs/CreateOverChargeSettlements';

const CreateOverChargeClaimTab = ({
  activeKey,
  setActiveKey,
  detailsForm,
  itemList = [],
  setItemList,
  notesList = [],
  setNotesList,
  settlementList = [],
  setSettlementList,
  initialValues,
}) => {
  return (
    <CollapsiblePanel
      forceRender
      handleTabClick={(keys) => setActiveKey(keys)}
      activeKey={activeKey}
      tabs={[
        {
          content: <CreateOverChargeDetails detailsForm={detailsForm} initialValues={initialValues} />,
          header: <GenerateTitle title="Details" Icon={DetailsIcon} size={25} />,
          tabKey: '1',
        },
        {
          content: <CreateOverChargeItems itemList={itemList} setItemList={setItemList} />,
          header: <GenerateTitle title="Overcharge Claim Items" Icon={TruckIcon} size={25} />,
          tabKey: '2',
        },
        {
          content: <CreateOverChargeNotes notesList={notesList} setNotesList={setNotesList} />,
          header: <GenerateTitle title="Overcharge Claim Notes" Icon={NotesIcon} size={25} />,
          tabKey: '3',
        },
        {
          content: (
            <CreateOverChargeSettlements settlementList={settlementList} setSettlementList={setSettlementList} />
          ),
          header: <GenerateTitle title="Overcharge Claim Settlements" Icon={SettlementIcon} size={25} />,
          tabKey: '4',
        },
      ]}
    />
  );
};

export default CreateOverChargeClaimTab;

const GenerateTitle = ({ title, Icon, size = 25 }) => {
  return (
    <Row gutter={10} align="middle">
      <Col className="lh-0">
        <SvgConverter width={size} height={size} Icon={Icon} />
      </Col>
      <Col className="lh-0">
        <label className="lh-0 text-dark cursor-pointer">{title}</label>
      </Col>
    </Row>
  );
};
